// methods related to the manage group page

const Group = {};

// Clears group credentials from local storage.
Group.clearGroupFromLocalStorage = function() {
	localStorage.setItem(Constants.EncryptionKeyItemName, null);
	localStorage.setItem(Constants.CloudGroupVersionItemName, null);
};

// Creates a new V1 group in the cloud and store the key.
Group.createAndStoreGroup = async (usageCode) => {
	const createResult = await Cloud.createGroup(usageCode);
	if (createResult.success) {
		CP.storeEncryptionKey(createResult.encryptionKey, Constants.CurrentVersion);
		Group.inviteCode = createResult.inviteCode;
	}
	return createResult;
};

// Current invite code to display
Group.inviteCode = null;

// The group name text in the UI
Group.currentGroupNameInUI = "";

// Check if dev mode is on or not
Group.isDevModeOn = function() {
	try {
		return new URLSearchParams(window.location.search).get('devmode') === 'true';
	}
	catch (error) {
		console.error("Failure when trying to get devmode from URL!", error);
		CP.showErrorMessage("An unexpected failure occureed when trying to get development mode!");
	}
	return false;
};

Group.groupIdBubble = null;

Group.v0WarningBubble = null;

Group.showGroupID = () => {
	let encrkey = CP.retrieveEncryptionKey()?.groupID;
	try {
		let base64 = CryptoUtil.bytesToBase64(encrkey);
		let groupIdArea = CP.getel('groupIdArea');
		if (Group.groupIdBubble === null)
			Group.groupIdBubble = new CP.TextBubble(groupIdArea, 'Group ID: ' + base64,
				CP.TextBubbleStyle.Notification, null, false);
		CP.showEl(groupIdArea);
	}
	catch (error) {
		console.error("Failure getting group id!", error);
		CP.showErrorMessage("An unexpected failure occurred when trying to get the group ID!");
	}
};

Group.hideGroupID = () => {
	let groupIdArea = CP.getel('groupIdArea');
	if (Group.groupIdBubble !== null)
		Group.groupIdBubble.setText('', false);
	CP.hideEl(groupIdArea);
};

Group.updateGroupNameInUI = async function(linked)
{
	try {
		let groupName = '';
		if (linked)
		{
			// Get group name
			var groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();
			var indexRes = await Cloud.getIndexFromCloud(groupInfo);

			if(!indexRes.success)
			{
				let indexObjName = Cloud.getIndexObjectName(groupInfo);
				CP.showErrorMessage("Failed to download group information from cloud ("
				+ indexObjName + "). HTTP status code: " + indexRes.httpStatusCode);
			}
			else
			{
				if (indexRes.indexFile.GroupName != null)
				{
					groupName = indexRes.indexFile.GroupName;
				}
			}
			let groupNameInputUpdate = CP.getel("groupNameInputUpdate");
			groupNameInputUpdate.value = groupName;
			Group.currentGroupNameInUI = groupName;
		}
		else
		{
			var groupNameInput = CP.getel("groupNameInput");
			groupName = Util.getCurrentFormattedUTCDateForUI();
			groupNameInput.value = groupName;
			Group.currentGroupNameInUI = groupName;
		}
	}
	catch (error) {
		console.error('Failure to update group name in UI', error);
		CP.showErrorMessage("An unexpected error occurred while trying to update group name in the UI!");
	}
};

Group.showInviteCode = function(inviteCode)
{
	let textSpan = CP.getel('inviteCodeText');
	textSpan.textContent = inviteCode;
};

Group.showV0WarningIfNeeded = async function() {
	if (CP.isLinked()) {
		try {
			const groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();
			if (groupInfo && groupInfo.version === Constants.CloudSystemVersionZero) {
				const message = "Arkio 2.0 introduces scene sharing, issue exports, and improved cloud performance. Please leave this group and create a new cloud group to enable these enhancements. Make sure to join the new group on all your devices";
				let bubble = new CP.TextBubble(CP.MsgManager.errorArea, message, CP.TextBubbleStyle.Warning, "Please create a new group", true);
				Group.v0WarningBubble = bubble;
				bubble.onDismiss = () => { Group.v0WarningBubble = null; };
			}
		} catch (error) {
			console.error("Failure when checking group version for warning message:", error);
		}
	}
};

// Update UI of manage group page
Group.updateUI = async function()
{
	let copyMessageSpan = CP.getel("CopyMessageSpan");
	CP.hideEl(copyMessageSpan);

	// Check if the group id can be retrieved from the URL
	let groupIdFromUrl = CP.getEncryptionKeyFromUrl('groupid') === null ? false : true;

	// Check if we are linked to a group
	let linked = CP.isLinked();

	let unlinkButton = CP.getel("unlinkButton");
	let createNewGroupSection = CP.getel("CreateNewGroupSection");
	let joinGroupSection = CP.getel("JoinGroupSection");
	let linkedGroupSection = CP.getel("LinkedGroupSection");
	let inviteCodeSection = CP.getel("InviteCodeSection");

	CP.setVisibility(unlinkButton, !groupIdFromUrl);
	CP.setVisibility(createNewGroupSection, !linked);
	CP.setVisibility(joinGroupSection, !linked);
	CP.setVisibility(linkedGroupSection, linked);

	if (linked) {
		if (Group.isDevModeOn()) Group.showGroupID();
		else Group.hideGroupID();
		if (Group.inviteCode != null) {
			let inviteCodeSpan = CP.getel('inviteCodeText');
			inviteCodeSpan.textContent = Group.inviteCode;
			CP.showEl(inviteCodeSection);
		}
		else CP.hideEl(inviteCodeSection);
	} else {
		CP.hideEl(inviteCodeSection);
		Group.hideGroupID();
	}

	Group.showV0WarningIfNeeded();

	// Enable/disable the tabs
	await CP.setNavigationTabsState();

	Group.updateGroupNameInUI(linked);
};

Group.unlinkFromCloud = async function()
{
	encryptionKey = null;
	Group.clearGroupFromLocalStorage();
		CP.notify("Left Group!", false);
		if (Group.v0WarningBubble) Group.v0WarningBubble.remove();
		await Group.updateUI();
};

Group.createNewGroup = async () =>
{
	const result = await Group.createAndStoreGroup(0);
	if(result.success)
	{
		await Group.setGroupName(false);
		CP.notify('Created new group. Invite code: ' + result.inviteCode, false);
	}
	else
	{
		CP.showErrorMessage("Group creation failed!");
	}
	
	await Group.updateUI();
};

// Create an invite code for an already existing connection
Group.createInviteCode = async () => {
	if (CP.isLinked()) {
		let groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();
		let result = await Cloud.getNewInviteCode(groupInfo.groupID,
			groupInfo.version !== null && groupInfo.version !== Constants.CloudSystemVersionZero ? 0 : null);
		if (result.success) {
			CP.notify('New invite code: ' + result.inviteCode, false);
			Group.inviteCode = result.inviteCode;
		} else {
			CP.showErrorMessage("Failed to get invite code!");
		}
		await Group.updateUI();
	} else {
		// If user is not linked then leave group
		Group.unlinkFromCloud();
	}
};

Group.linkWithCloud = async () =>
{
	var keycodeInputEl = CP.getel("keycodeInput");
	var code = keycodeInputEl.value;
	code = code.trim();

	if (Group.isDevModeOn()) {
		let groupID = CP.convertGroupIDFromBase64(code);
		if (groupID) {
			console.log('Storing encryption key from input field: ' + code);
			//TODO see if we can get the cloud group version here
			// Maybe by trying to get index file using group id and hashed group id
			CP.storeEncryptionKey(groupID, null);
			CP.notify("Joined group using group ID!", false);
			await Group.updateUI();
		} else {
			CP.showErrorMessage("Unexpected error while processing key!");
		}
		return;
	}

	code = code.toUpperCase();
	keycodeInputEl.value = code;

	if (code.length !== 6) {
		CP.showErrorMessage('Length of invite code should be 6 letters!');
		return;
	}

	var result = await Cloud.getGroupID(code);
	if (result.success) {
		CP.notify("Joined Group!", false);
		CP.storeEncryptionKey(result.groupID, result.version);
	} else {
		if (result.httpStatusCode === 404) CP.showErrorMessage("Code does not exist!");
		else CP.showErrorMessage("Something went wrong!");
	}
	await Group.updateUI();
};

Group.copyURL = async () => {
	let encrkey = CP.retrieveEncryptionKey()?.groupID;
	if (encrkey === null) {
		let msg = "Could not retrieve the encryption key!";
		console.error(msg);
		CP.showErrorMessage(msg);
		return;
	}
	try {
		let url = `${CP.getSiteBaseUrl()}?groupid=${CP.getBytesAsURIComponent(encrkey)}`;
		// Copy the url to the clipboard
		// Show a message to the user about the url being copied
		if (await CP.copyToClipboard(url)) CP.showEl(CP.getel("CopyMessageSpan"));
		else CP.showErrorMessage("Failed to copy text to the clipboard!");
	} catch (error) {
		console.error("Failure getting group URL!", error);
		CP.showErrorMessage("An unexpected failure occurred when trying to get the group URL!");
	}
};

// Gets group name from UI and sets it in the cloud
// Updates the UI after setting the group name
Group.setGroupName = async (update) => {

	if (!CP.isLinked())
	{
		// If not linked then make sure the page shows that
		Group.unlinkFromCloud();
		return;
	}

	// disable group name input box and button while setting the group name
	let groupNameInputUpdate = CP.getel('groupNameInputUpdate');
	groupNameInputUpdate.disabled = true;

	CP.notify("Setting group name.", true);
	console.log('Getting encryption key.');
	var groupInfo = await CP.retrieveEncryptionKeyAndCheckVersion();

	let groupName = "";
	if (update)
	{
		let groupNameInputUpdate = CP.getel('groupNameInputUpdate');
		groupName = groupNameInputUpdate.value;
	}
	else
	{
		let groupNameInput = CP.getel('groupNameInput');
		groupName = groupNameInput.value;
	}

	console.log("Attempting to set group name to: " + groupName);

	let res = await Cloud.setGroupName(groupName, groupInfo);
	if (res.success)
	{
		CP.notify("Group name set to " + groupName + '.', false);
	}
	else
	{
		CP.showErrorMessage("Failed to set group name!");
	}

	groupNameInputUpdate.disabled = false;

	await Group.updateUI();
};

// Reads the value in the group name update input box
// and if it has changed then update the group name
// in the cloud
Group.updateGroupNameIfNeeded = async function()
{
	let groupNameTextbox = CP.getel("groupNameInputUpdate");
	let newGroupName = groupNameTextbox.value;
	if (Group.currentGroupNameInUI !== newGroupName) await Group.setGroupName(true);
};

Group.groupNameKeyDown = async function(event) {
	if (event.key === "Enter") {
		await Group.updateGroupNameIfNeeded();
	}
};

Group.groupNameBlur = async function(event) {
	await Group.updateGroupNameIfNeeded();
};

Group.DOMContentLoaded = () => {
	CP.initMsgManager(CP.getel('errorArea'), CP.getel('staticMessageArea'), CP.getel('notificationArea'));
	CP.addStaticText(CP.getel('groupPageMessage').innerHTML);

	CP.getel("copyButtonSpan").addEventListener("click", async () => {
		CP.notify("Copying invite code", true);
		let inviteCode = CP.getel('inviteCodeText').innerHTML;
		await CP.copyToClipboard(inviteCode);
		CP.notify("Invite code " + inviteCode + " copied to clipboard.", false);
	});
};

Group.bodyOnLoad = async function()
{
	await CP.initPage({publicPage : true});

	// For showing an error message if user clicks on one
	// of those disabled tabs when not connected to a group.
	CP.getNonGroupTabListItems().forEach(function(item, index) {
		item.addEventListener('click', function(event) {
				if (!CP.isLinked()) CP.showErrorMessage(
				"Create or join a cloud group to access uploads or Arkio Exports.");
		});
	});

	let groupNameTextbox = CP.getel("groupNameInputUpdate");
	// Add event listener for keydown event
	groupNameTextbox.addEventListener("keydown", Group.groupNameKeyDown);
	// Add event listener for blur event
	groupNameTextbox.addEventListener("blur", Group.groupNameBlur);

	await Group.updateUI();
};
